import TypesenseInstantsearchAdapter from 'typesense-instantsearch-adapter';
import { calculateIntersectionScore, extractFacetValues } from './typesense';

export const createFacetRankingSearchClient = (
  baseClient: TypesenseInstantsearchAdapter['searchClient'],
): TypesenseInstantsearchAdapter['searchClient'] => ({
  ...baseClient,
  search(requests) {
    return baseClient.search(requests).then((results) => ({
      ...results,
      results: results.results.map((result, index) => {
        const selectedSubtopics = extractFacetValues(
          requests[index].params?.facetFilters,
          'subtopic',
        );
        const selectedAreas = extractFacetValues(requests[index].params?.facetFilters, 'area');

        // Re-rank when any subtopics or areas are selected
        if ((selectedSubtopics.length === 0 && selectedAreas.length === 0) || !result.hits)
          return result;

        const rankedHits = [...result.hits].sort((a, b) => {
          const subtopicScoreA = calculateIntersectionScore(a.subtopic, selectedSubtopics);
          const subtopicScoreB = calculateIntersectionScore(b.subtopic, selectedSubtopics);
          const areaScoreA = calculateIntersectionScore(a.area, selectedAreas);
          const areaScoreB = calculateIntersectionScore(b.area, selectedAreas);

          const totalScoreA = subtopicScoreA + areaScoreA;
          const totalScoreB = subtopicScoreB + areaScoreB;

          // Primary sort: by total intersection score (descending)
          if (totalScoreB !== totalScoreA) return totalScoreB - totalScoreA;

          // Secondary sort: preserve original order for same scores
          return result.hits.indexOf(a) - result.hits.indexOf(b);
        });

        return { ...result, hits: rankedHits };
      }),
    }));
  },
});
